import React from "react";
import { dateIsInTimePeriod } from "./helpers";

function useModalController() {
  const getInfo = (type) => {
    const res = localStorage.getItem(type);
    return res === "undefined" ? null : JSON.parse(res);
  };

  const setInfo = (type, data) => {
    localStorage.setItem(type, JSON.stringify(data));
  };

  const updateInfo = (type, data) => {
    const prev = getInfo(type);
    setInfo(type, { ...prev, ...data });
  };

  const deleteInfo = (key) => {
    localStorage.clear(key);
  };

  // TODO -> refactor
  const onDisplayHandler = (type, config) => {
    const { number, timePeriod, restTime } = config;
    const prevInfo = getInfo(type);

    if (!number) {
      deleteInfo(type);
      return true;
    }

    if (
      !prevInfo ||
      prevInfo.number !== number ||
      prevInfo.timePeriod !== timePeriod
    ) {
      setInfo(type, {
        timePeriod,
        number,
        count: 0,
        date: new Date(),
      });
      return true;
    }

    if (dateIsInTimePeriod(new Date(prevInfo?.date), timePeriod)) {
      if (prevInfo.count >= number) {
        return false;
      }

      if (restTime && new Date().getTime() < prevInfo.lastDisplay + restTime) {
        return false;
      }

      return true;
    } else {
      setInfo(type, {
        count: 0,
        timePeriod,
        number,
        date: new Date(),
      });
      return true;
    }
  };

  const onCloseHandler = ({ type }) => {
    const prev = getInfo(type);

    let res = { lastDisplay: new Date().getTime() };

    if (typeof prev?.count === "number") {
      res.count = prev.count + 1;
    }

    updateInfo(type, res);
  };

  return [onDisplayHandler, onCloseHandler];
}

export default useModalController;
